import { render } from "./Agenda.vue?vue&type=template&id=4f859b16&scoped=true&ts=true"
import script from "./Agenda.vue?vue&type=script&lang=ts"
export * from "./Agenda.vue?vue&type=script&lang=ts"

import "./Agenda.vue?vue&type=style&index=0&id=4f859b16&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f859b16"]])

export default __exports__